import {
  CHECKIN_PAYMENT,
  CHECKIN_THANKYOU,
  HOME,
  KEY,
} from "../../routes/Paths";
import {
  CONFIG_MASTER_ENUM,
  SESSION_ENUM,
  STEP_MASTER_ENUM,
} from "../../constants/constant";
import { timerConstantValue } from "../../constants/timers";
import {
  checkIn,
  getReservationPaymentInfo,
  getState,
  queueRoom,
  saveRegistrationCard,
  updateUserProfile,
  verifyQueueOrCheckin,
} from "../../network/apiService";
import {
  fetchCountries,
  getCountryList,
  getProfilesListData,
} from "../../store/Checkin/reservationformSlice";
import { fetchStep, postAuditLog, getIsSkipped } from "../../store/stageSlice";
import {
  formatDate,
  getConfigurationCode,
  getParametersFromLocalStorage,
  getProfileName,
  homePageHandler,
  isValidStr
} from "../../helpers/commonHelper";
import { initReactI18next, useTranslation } from "react-i18next";
import {
  resetScanPassportGuestCount,
  setEmailDetails,
  userReservationDetailsPassport,
} from "../../store/Checkin/Scan/scanPassportSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import CheckoutTimeModal from "../../components/Layout/Card/CheckoutTimeModal";
import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import Footer from "../../components/Layout/Footer";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import MultipleRegCard from "../../components/Layout/Card/MultipleRegCard";
import SuccessPopup from "../../components/LoaderAndNotification/SuccessPopup";
import UserReservationAddressDetails from "../../components/ReservationDetails/UserReservationAddressDetails";
import UserReservationDetails from "../../components/ReservationDetails/UserReservationDetails";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getPassportScanData } from "../../store/Checkin/Scan/scanPassportSlice";
import { getPostalCodeDetails } from "../../store/Checkin/reservationDetailsSlice";
import {
  getProfileData,
  fetchDocumentTypes,
  getDocumentListTypes,
} from "../../store/Checkin/Scan/documentScanSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import { getStepMaster } from "../../helpers/commonHelper";
import i18n from "i18next";
//import moment from "moment";
import { setMultiConfirmationNos,setCheckoutTime,setDepartureDate } from "../../store/Checkin/ConfirmationNumber/confirmationNumberSlice";
import { useNavigate } from "react-router-dom";
import useUserActivity from "../../hooks/useUserActivity";
import { getUserConsentMaster } from "../../network/apiService";
import {
  toPropertyTime12h,
  utcToPropertyTime24h,
  propertyTimeToUtc
} from "../../constants/timeUtils";
import moment from "moment-timezone";

const ReservationDetailsPassportScan = () => {
  //const userData = useSelector(getPassportScanData);
  const timeLimit = timerConstantValue;
  let noOfNights = null;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [enterEmailValidation, setEnterEmailValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  // const [jobTitleValidation, setJobTitleValidation] = useState(false);
  const [udfFieldValidation, setUdfFieldValidation] = useState(false);
  const [udfField2Validation, setUdfField2Validation] = useState(false);
  const [udfField3Validation, setUdfField3Validation] = useState(false);
  const [udfField4Validation, setUdfField4Validation] = useState(false);
  const [firstNameValidation, setFirstNameValidation] = useState(false);
  const [lastNameValidation, setLastNameValidation] = useState(false);
  const [documentNumberValidation, setDocumentNumberValidation] =
    useState(false);
  const [documentTypeValidation, setDocumentTypeValidation] = useState(false);
  const [genderValidation, setGenderValidation] = useState(false);
  const [addressLine1Validation, setAddressLine1Validation] = useState(false);
  const [countryValidation, setCountryValidation] = useState(false);
  // const [nationalityValidation, setNationalityValidation] = useState(false);
  const [mobileNoValidation, setMobileNoValidation] = useState(false);
    const [checkoutTimeValidation, setCheckoutTimeValidation] = useState(false);
  const [enterPincodeValidation, setEnterPincodeValidation] = useState(false);
  const [enterJobTitleValidation, setEnterJobTitleValidation] = useState(false);
  const [enterCityValidation, setEnterCityValidation] = useState(false);
  const [enterStateValidation, setEnterStateValidation] = useState(false);

  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const [toggleCheckoutTimeModal, setToggleCheckoutTimeModal] = useState(false);
  const [successLoader, setSuccessLoader] = useState(false);
  const [togglePackageApi, setTogglePackageApi] = useState(false);
  const [timeChanged, setTimeChanged] = useState(false);
  const [totalCount, setTotalCount] = useState(false);
  const [totalDue, setTotalDue] = useState(null);
  const [reservationData, setReservationData] = useState();
  const [confirmationDetails, setConfirmationDetails] = useState(null);

  const [successMessage, setSuccessMessage] = useState(null);
  const [successMessage2, setSuccessMessage2] = useState(null);
  const [isSkipRegCard, setIsSkipRegCard] = useState(null);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [erroModalData2, setErrorModalData2] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [erroModalData3, setErrorModalData3] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [erroModalData4, setErrorModalData4] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [userAgreed, setUserAgreed] = useState(false);
  //User consent
  const [userConsents, setUserConsents] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [greenImperativeConsent, setGreenImperativeConsent] = useState(false);
  const [marketingConsent1, setMarketingConsent1] = useState(false);
  const [marketingConsent2, setMarketingConsent2] = useState(false);

  const [regCardConsent1, setRegCardConsent1] = useState(false);
  const [regCardConsent2, setRegCardConsent2] = useState(false);
  const [regCardConsent3, setRegCardConsent3] = useState(false);

  const [signature, setSignature] = useState(null);
  const [url, setUrl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getParametersFromLocalStorage("token");
  const [stage, setStage] = useState(false);
  const userDataDeatils = useSelector(getPassportScanData);

  const [proceedCount, setProceedCount] = useState(0);
  const [guestCount, setGuestCount] = useState(0);

  const [userData, setUserData] = useState(userDataDeatils);
  const [closeModal, setCloseModal] = useState(false);
  const [showMultiConfirmModal, setShowMultiConfirmModal] = useState(false);
  const confirmNo = localStorage.getItem("confirmationNo");
  const reservationNameID = localStorage.getItem("reservationNameID");
  const propertyCode = localStorage.getItem("propertyCode");
  const countries = useSelector(getCountryList);
  const documentListTypes = useSelector(getDocumentListTypes);
  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const inputFieldList = getParametersFromLocalStorage("InputFieldList");
  const popupList = getParametersFromLocalStorage("PopupList");
  const reservationDetailsPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.REGISTRATION_CARD_PAGE
  );
  const [confirmationNos, setConfirmationNos] = useState([]);
  const [isDoCheckin, setDoCheckin] = useState(false);
  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };
  const [popupModalData, setPopupModalData] = useState({
    toggleError: false,
  });
  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const openCheckOutTimeModal = () => {
    setToggleCheckoutTimeModal(true);
  };

  const closeCheckoutTimeModal = () => {
    setToggleCheckoutTimeModal(false);
    setTimeChanged(false);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };
  const paymentPage = getStepMaster(stepMaster, STEP_MASTER_ENUM.PAYMENT_PAGE);

  const confirmSharerReg = () => {
    setShowMultiConfirmModal(false);
    setLoading(true);
    let fullName = "";
    var profileInfo = {};
    if (
      profileData[proceedCount] !== null &&
      profileData[proceedCount] !== undefined
    ) {
      fullName = getProfileName(null, null, profileData[proceedCount]);
    } else {
      fullName = getProfileName(null, null, profileList[guestCount]);
    }

    if (
      profileList[guestCount] !== null &&
      profileList[guestCount] !== undefined
    ) {
      profileInfo = profileList[guestCount];
    } else {
      profileInfo = profileData[proceedCount];
    }
    var docProfileInfo = profileData[guestCount];

    var gender = "M";
    if (((profileInfo?.gender ?? "U").toUpperCase().includes("U") 
      || !isValidStr(profileInfo?.gender))
      && isValidStr(docProfileInfo?.gender)) {
      gender = docProfileInfo?.gender;
    } else {
      gender = profileInfo?.gender
    }

    if (gender) {
      gender = gender.toLowerCase().includes("f") ? "F" : "M";
    }
    
    setTimeout(() => {
      setReservationData((prevState) => ({
        ...prevState,
        pmsConfirmationNo: profileInfo?.pmsConfirmationNo,
        pmsProfileID: profileInfo?.pmsProfileID,
        firstName: profileInfo?.FirstName,
        name: fullName, //profileInfo?.GivenName,
        email: profileInfo?.email ?? "",
        jobTitle: profileInfo?.jobTitle ?? "",
        udfField: profileInfo?.udfField ?? "",
        udfField2: profileInfo?.udfField2 ?? "",
        udfField3: profileInfo?.udfField3 ?? "",
        udfField4: profileInfo?.udfField4 ?? "",
        mobileNo: profileInfo?.phoneNo_Res ? profileList[0]?.phoneNo_Res : "",
        lastName: profileInfo?.LastName,
        adults: 0,
        roomRate: profileInfo?.rateCodeAmount || "0.0",
        totalAmount: profileInfo?.totalAmount || "0.0",
        balanceAmount: profileInfo?.balanceAmount || "0.0",
        totalAmountDue: profileInfo?.totalAmountDue,
        nationality: profileInfo?.nationality,
        pincode: profileInfo?.pincode || "",
        // street: profileInfo?.street || "",
        neighborhood: profileInfo?.neighborhood || "",
        city: profileInfo?.city || "",
        state: profileInfo?.state || "",
        gender: gender,
        complement: profileInfo?.complement || "",
        issueCountry: profileInfo?.issueCountry || "",
        addressLine1: primaryAddressData?.street?.trim() || "",
        addressLine2: profileInfo?.addressLine2 || "",
        country: primaryAddressData.countryOfResidenceCode, // Accompany sharers will inherit the address details of it primary sharer
        documentNumber:
          docProfileInfo?.documentNumber ?? profileInfo?.documentNumber ?? "",
        documentType:
          docProfileInfo?.documentType ?? profileInfo?.documentNumber ?? "",
        // reservationNameID: profileInfo?.reservationNameID
      }));
      setConfirmationDetails({
        email: profileInfo?.email ?? "",
        jobTitle: profileInfo?.jobTitle ?? "",
        udfField: profileInfo?.udfField ?? "",
        udfField2: profileInfo?.udfField2 ?? "",
        udfField3: profileInfo?.udfField3 ?? "",
        udfField4: profileInfo?.udfField4 ?? "",
        mobileNo: profileInfo?.phoneNo_Res ? profileList[0]?.phoneNo_Res : "",
        //country: profileInfo?.countryCode,
        country: primaryAddressData.countryOfResidenceCode,
        pmsConfirmationNo: profileInfo?.pmsConfirmationNo,
        reservationNameID: profileInfo?.reservationNameID,
        firstName: profileInfo?.FirstName,
        lastName: profileInfo?.LastName,
        gender: gender,
        name: fullName,
        nationality: profileInfo?.nationality,
        pincode: profileInfo?.pincode || "",
        issueCountry: profileInfo?.issueCountry || "",
        //street: profileInfo?.street || "",
        neighborhood: profileInfo?.neighborhood || "",
        city: profileInfo?.city || "",
        state: profileInfo?.state || "",
        complement: profileInfo?.complement || "",
        addressLine1: primaryAddressData?.street?.trim() || "",
        addressLine2: profileInfo?.addressLine2 || "",
        documentNumber:
          docProfileInfo?.documentNumber ?? profileInfo?.documentNumber ?? "",
        documentType:
          docProfileInfo?.documentType ?? profileInfo?.documentNumber ?? "",
        //profileData[proceedCount]?.GivenName,
        //checkOutTime:profileInfo?.checkOutTime
         checkoutTime: 
          (() => {
            const formattedTime = moment(profileInfo?.checkOutTime).format("hh:mm A") || "";
            const dbCheckoutTime = settings?.find((setting) => setting.parameterName === "CheckOutTime")?.parameterValue ?? "09:00 AM";
            return (formattedTime === "12:00 AM" || formattedTime === "00:00 AM") ? dbCheckoutTime : formattedTime;
          })(),
         // departureDate: profileInfo?.departureDate || "",
      });

      setAddressData({
        pincode: primaryAddressData?.pincode?.trim() || "",
        street: primaryAddressData?.street?.trim() || "",
        neighborhood: primaryAddressData?.neighborhood?.trim() || "",
        city: primaryAddressData?.city?.trim() || "",
        state: primaryAddressData?.state?.trim() || "",
        complement: primaryAddressData?.complement?.trim() || "",
        numberofResidence: primaryAddressData?.numberofResidence?.trim() || "",
      });
      // setnumberofResidence(profileData[proceedCount]?.addressLine2 || "");
      clearSign();
      setShowDiv(true);
      setLoading(false);
    }, 2000);

    //api call to save reg card & checkin
  };
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);
  const [addressData, setAddressData] = useState();
  const [primaryAddressData, setPrimaryAddressData] = useState();
  const [isPrimarySharer, setIsPrimarySharer] = useState(true);
  const [userDefinedFields, setUserDefinedFields] = useState();
  const [showingPopup, setShowingPopup] = useState(false);
  const settings = getParametersFromLocalStorage("settings");
  const countryCodeAddressUpdate = settings?.find(
    (setting) => setting.parameterName === "ThreeCountryCodeForAddressUpdate"
  );
   const enableJuridictionStateCode = settings?.find(
    (setting) => setting.parameterName === "EnableJuridictionStateCode"
  );
  const enableTimeZoneBasedCheckoutUpdate =(settings?.find(
    (setting) => setting.parameterName === "EnableTimeZoneBasedCheckoutUpdate"
  )?.parameterValue ?? "false").toLowerCase()  === "true";
  // useEffect(() => {

  //   fetchPostalDetails();
  // }, []);

  const [zipCode, setZipCode] = useState(confirmationDetails?.pincode ?? "");
  // const [numberofResidence, setnumberofResidence] = useState(
  //   confirmationDetails?.addressLine2 ?? ""
  // );

  const showModalPopupModal = (status) => {
    setShowingPopup(status);
  };

  const closeModalPopup = () => {
    setShowingPopup(false);
  };
  // const closeAddressPopup = () => {
  //   setPopupModalData((state) => ({
  //     ...state,
  //     toggleError: false,
  //   }));
  // };

  const onError = (msg) => {
    setErrorModalData4((state) => ({
      ...state,
      toggleError: true,
      errorMessage: t(msg),
    }));
  };
  const onLoader = (flag) => {
    setLoading(flag);
  };
  //KC-443 Email Domain needs to be configurable

  const enableAutomaticEmailDomain = settings?.find(
    (setting) =>
      setting.parameterName === "EnableAutomaticEmailDomain" &&
      setting.parameterValue?.toLowerCase() === "true"
  );

  const onAddressSubmit = (address) => {
    setAddressData({
      pincode: address?.pincode,
      street: address?.street,
      neighborhood: address?.neighborhood,
      complement: address?.complement,
      city: address?.city,
      state: address?.state,
      numberofResidence: address?.numberofResidence,
    });

    if (isPrimarySharer) {
      var countryOfResidenceCode = primaryAddressData.countryOfResidenceCode;
      setPrimaryAddressData({
        pincode: address?.pincode,
        street: address?.street,
        neighborhood: address?.neighborhood,
        complement: address?.complement,
        city: address?.city,
        state: address?.state,
        numberofResidence: address?.numberofResidence,
        countryOfResidenceCode: countryOfResidenceCode,
      });
    }
    closeModalPopup();
  };

  const fetchPostalDetails1 = () => {
    if (!addressData || !addressData.pincode) {
      //setEnterPincodeValidation(true);
      setErrorModalData4((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t("Please Enter the Pincode to Proceed"),
      }));
      setTimeout(() => {
        setLoading(false);
      }, 1000);

      return;
    }

    dispatch(
      getPostalCodeDetails({
        postalCode: addressData.pincode,
        token: token,
      })
    )
      .unwrap()
      .then((rep) => {
        console.log("error" + rep);
        setAddressData(rep);
        //fetchpostalCodeCompleted(rep);
      })
      .catch((error) => {
        console.log("error" + error);
        setLoading(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: error?.error ?? t("Please try with a valid pincode"),
        }));
        return;
      });
  };

  // Define fetchConsents to get user consents from API
  const fetchConsents = async () => {
    try {
      const response = await getUserConsentMaster(token);
      if (response.status === 200) {
        const data = response?.data?.data || response?.data || [];
        setUserConsents(data.filter((consent) => consent.isActive));
      }
    } catch (error) {
      console.error("Failed to fetch consents", error);
    }
  };

  const fetchStates = async (country) => {
    try {
      const response = await getState(token, country ?? "");
      if (response.status === 200) {
        const data = response?.data?.data || response?.data || [];
        setStateList(
          data.filter(
            (state) =>
              !country ||
              state.countryCode === country ||
              state.twoCountryCode === country
          )
        );
      }
    } catch (error) {
      console.error("Failed to fetch consents", error);
    }
  };

  // Call fetchConsents once when component mounts
  useEffect(() => {
    fetchConsents();
  }, []);

  useEffect(() => {
    setDoCheckin(false);

    if (reservationDetailsPage === false) {
      navigate(`${CHECKIN_PAYMENT}`, { replace: true });
      return;
    }
    if (
      (countries === null || countries === undefined) &&
      token !== null &&
      token !== undefined
    ) {
      dispatch(fetchCountries(token));
    }

    if (
      (documentListTypes === null || documentListTypes === undefined) &&
      token !== null &&
      token !== undefined
    ) {
      dispatch(fetchDocumentTypes(token));
    }
  }, []);
  //KC-447 Timer need to restart when user interaction is involved
  useUserActivity(() => {
    setTimerValue(timeLimit);
  });

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
    setShowDiv(false);
  }, []);
  useEffect(() => {
    if (
      confirmNo != null &&
      confirmNo !== undefined &&
      propertyCode !== null &&
      propertyCode !== undefined
    ) {
      dispatch(
        fetchStep({
          confirmationNo: confirmNo,
          propertyCode: propertyCode,
          type: "checkin",
          token: token,
          stepCode: "SEI04",
          profile: null,
        })
      )
        .unwrap()
        .then((response) => {
          console.log("isSkipRegCard==>" + response);
          dispatch(resetScanPassportGuestCount());
          fetchReservationDetails(
            {
              ConfirmationNo: confirmNo,
              PropertyCode: propertyCode,
              ReservationNameID: reservationNameID,
            },
            response
          );
        });
    }
  }, [confirmNo, propertyCode]);

  const findNumberOfNights = (arrivalDate, departureDate) => {
    let noOfNights = null;
    if (arrivalDate && departureDate) {
      const date1 = new Date(moment(arrivalDate).format("YYYY-MM-DD"));
      const date2 = new Date(moment(departureDate).format("YYYY-MM-DD"));
      const timeDiff = date2.getTime() - date1.getTime();
      const nights = Math.ceil(timeDiff / (1000 * 3600 * 24));
      noOfNights = nights;
    }
    return noOfNights;
  };

  const profileData = useSelector(getProfileData);
  const propertyData = useSelector(getPropertyInfo);
  
  const profileList = useSelector(getProfilesListData);
  
  const fetchReservationDetails = async (query, isSkipRegCard) => {
    setLoading(true);
    try {
    
      // checkStep();
      const response = await getReservationPaymentInfo(query, token);
      var countryOfResidenceCode = isPrimarySharer
        ? response?.data?.data?.countryOfResidenceCode
        : primaryAddressData.countryOfResidenceCode;
      //   var loadStateRequest=countryOfResidenceCode?countryOfResidenceCode:profileInfo?.IssueCountryCode
      if (countryOfResidenceCode) {
        fetchStates(countryOfResidenceCode);
      }
      var profileInfo = {};
      var documentType = "";
      if (profileData != null) {
        profileInfo = profileData[guestCount];
        documentType = profileInfo?.DocumentType ?? profileInfo?.documentType;
      } else {
        profileInfo = profileList[guestCount];
        documentType = profileInfo?.DocumentType ?? profileInfo?.documentType;
        documentType = documentListTypes.filter(
          (m) => m.OperaDocumentCode === documentType
        )[0]?.BODocumentType;
      }
      var stateCode="";
      if(enableJuridictionStateCode?.parameterValue?.toLowerCase() === "true")
      {
        stateCode=profileInfo?.JurisdictionCode?profileInfo?.JurisdictionCode:response?.data?.data?.state;
      }
      else
      {
        stateCode=response?.data?.data?.state;
      }
      var loadStateRequest=profileInfo?.IssueCountryCode?profileInfo?.IssueCountryCode:countryOfResidenceCode;
      if (loadStateRequest) {
        fetchStates(loadStateRequest);
      }
      //const response = await getReservationDetails(query, token);
      if (response?.data?.result === true && response.data.data != null) {
        dispatch(userReservationDetailsPassport(response?.data?.data));

        noOfNights = findNumberOfNights(
          response?.data?.data?.arrivalDate,
          response?.data?.data?.departureDate
        );
        const amount = parseFloat(response.data?.data?.totalAmountDue ?? 0);

        var gender = "M";
        if (((response?.data?.data?.gender ?? "U").toUpperCase().includes("U") || !isValidStr(response?.data?.data?.gender)) 
          && isValidStr(profileInfo?.Gender ?? profileInfo?.gender)) {
          gender = profileInfo?.Gender ?? profileInfo?.gender;
        } else {
          gender = response?.data?.data?.gender;
        }
        setReservationData({
          firstName: response?.data?.data?.firstName,
          lastName: response?.data?.data?.lastName,
          name: getProfileName(null, null, response?.data?.data),
          roomNo: response?.data?.data?.roomNo || "",
          // arrivalDate:
          //   moment(response?.data?.data?.arrivalDate).format("YYYY-MM-DD") ||
          //   "",
          // departureDate:
          //   moment(response?.data?.data?.departureDate).format("YYYY-MM-DD") ||
          //   "",
          arrivalDate: formatDate(response?.data?.data?.arrivalDate),
          departureDate: formatDate(response?.data?.data?.departureDate),
          departureTime: response?.data?.data?.departureDate,
          nights: noOfNights,
          adults: response?.data?.data?.adultCount,
          child: response?.data?.data?.childCount,
          checkoutTime:
            moment(response?.data?.data?.departureDate).format("hh:mm A") || "",
          roomType: response?.data?.data?.roomTypeName || "",
          roomRate: response?.data?.data?.rateCodeAmount || "0.0",
          totalAmount: response?.data?.data?.totalAmount || "0.0",
          balanceAmount: response?.data?.data?.balanceAmount || "0.0",
          pmsProfileID: response?.data?.data?.pmsProfileID,
          pmsConfirmationNo: response?.data?.data?.pmsConfirmationNo,
          totalAmountDue: response.data?.data?.totalAmountDue,
         // country: countryOfResidenceCode,
         //country: countryOfResidenceCode?countryOfResidenceCode:profileInfo?.IssueCountryCode,
         country: profileInfo?.IssueCountryCode?profileInfo?.IssueCountryCode:countryOfResidenceCode,
          nationality: response.data?.data?.nationality,
          pincode: response.data?.data?.pincode,
          street: response.data?.data?.street,
          gender: gender,
          neighborhood: response.data?.data?.neighborhood,
          complement: response.data?.data?.complement,
          city: response.data?.data?.city,
          //state: response.data?.data?.state,
           state:stateCode,
          addressLine1: response.data?.data?.addressLine1,
          addressLine2: response.data?.data?.addressLine2,
          printRate: response.data?.data?.printRate,
          jobTitle: response.data?.data?.jobTitle,
          udfField: response?.data?.data?.udfField,
          udfField2: response?.data?.data?.udfField2,
          udfField3: response?.data?.data?.udfField3,
          udfField4: response?.data?.data?.udfField4,
          issueCountry: response?.data?.data?.issueCountry,
          documentNumber:
            profileInfo?.DocumentNumber ?? profileInfo?.documentNumber,
          documentType: documentType,
        });
        
        setConfirmationDetails((prev) => ({
          email: response?.data?.data?.email ?? "",
          //country: countryOfResidenceCode ?? "",
          // country: countryOfResidenceCode?countryOfResidenceCode:profileInfo?.IssueCountryCode,
            country:profileInfo?.IssueCountryCode?profileInfo?.IssueCountryCode:countryOfResidenceCode,
          mobileNo:
            response?.data?.data?.phoneNo_Res ||
            response?.data?.data?.phoneNo_UAE ||
            "",
          pmsConfirmationNo: response?.data?.data?.pmsConfirmationNo ?? "",
          reservationNameID: response?.data?.data?.reservationNameID ?? "",
          firstName: response?.data?.data?.firstName ?? "",
          lastName: response?.data?.data?.lastName ?? "",
          nationality:
            response?.data?.data?.nationalityCode ??
            response?.data?.data?.nationality ??
            profileInfo?.NationalityCode ??
            profileInfo?.nationalityCode ??
            response?.data?.data?.nationalityName,
          //nationality:  profileData[guestCount]?.NationalityCode,
          pincode: response?.data?.data?.pincode ?? "",
          neighborhood: response?.data?.data?.neighborhood ?? "",
          complement: response?.data?.data?.complement ?? "",
          city: response?.data?.data?.city ?? "",
          gender: gender,
          issueCountry: isValidStr(response?.data?.data?.issueCountry) ? response?.data?.data?.issueCountry : profileInfo?.IssueCountryCode ?? profileInfo?.issueCountryCode,
         // state: response?.data?.data?.state ?? "",
         // state:profileInfo?.JurisdictionCode?profileInfo?.JurisdictionCode:response?.data?.data?.state,
            state:stateCode,
          addressLine1: cleanAddress(response?.data?.data?.addressLine1 ?? ""), // Street
          addressLine2: response?.data?.data?.addressLine2 ?? "", // No of Residence
          jobTitle: response?.data?.data?.jobTitle,
          udfField: response?.data?.data?.udfField,
          documentNumber:
            profileInfo?.DocumentNumber ?? profileInfo?.documentNumber,
          documentType: documentType,
         // checkoutTime: moment(response?.data?.data?.departureDate).format("hh:mm A") || "",  
         checkoutTime: 
          (() => {
            let fctime;
             var propertyTimeZone=propertyData?.data?.timeZone ?? null;
             
             if(enableTimeZoneBasedCheckoutUpdate)
              {
                var localCheckoutTime=response?.data?.data?.departureDate? toPropertyTime12h(response?.data?.data?.departureDate,propertyTimeZone): "";
                var UTCCheckoutTime=localCheckoutTime? propertyTimeToUtc(localCheckoutTime,propertyTimeZone): "";
                 fctime= localCheckoutTime || "";
                 
              }  
            else
              {
                 fctime= moment(response?.data?.data?.departureDate).format("hh:mm A") || "";
              }
             const formattedTime = fctime; 
          //  const formattedTime = moment(response?.data?.data?.departureDate).format("hh:mm A") || "";
          //   const formattedTime = localCheckoutTime || "";

            const dbCheckoutTime = settings?.find((setting) => setting.parameterName === "CheckOutTime")?.parameterValue ?? "09:00 AM";
            return (formattedTime === "12:00 AM" || formattedTime === "00:00 AM") ? dbCheckoutTime : formattedTime;
          })(),
          departureDate: response?.data?.data?.departureDate || "",
        }));
        if (isPrimarySharer) {
          setAddressData({
            pincode: response.data?.data?.pincode,
            street: cleanAddress(response.data?.data?.addressLine1 ?? ""),
            neighborhood: response.data?.data?.neighborhood,
            complement: response.data?.data?.complement,
            city: response.data?.data?.city,
            state: response.data?.data?.state,
            numberofResidence: response.data?.data?.addressLine2,
          });

          setPrimaryAddressData({
            pincode: response.data?.data?.pincode,
            street: cleanAddress(response.data?.data?.addressLine1 ?? ""),
            neighborhood: response.data?.data?.neighborhood,
            complement: response.data?.data?.complement,
            city: response.data?.data?.city,
            state: response.data?.data?.state,
            numberofResidence: response.data?.data?.addressLine2,
            countryOfResidenceCode: countryOfResidenceCode,
          });
        } else {
          setAddressData({
            pincode: primaryAddressData?.pincode,
            street: primaryAddressData?.street,
            neighborhood: primaryAddressData?.neighborhood,
            complement: primaryAddressData?.complement,
            city: primaryAddressData?.city,
            state: primaryAddressData?.state,
            numberofResidence: primaryAddressData?.numberofResidence,
          });
        }

        // setUserDefinedFields({
        //   jobTitle:response?.data?.data?.jobTitle
        // });

        if (proceedCount == 0) {
          dispatch(
            setEmailDetails({
              mail: response?.data?.data?.email,
              phone: response?.data?.data?.phoneNo_Res,
            })
          );
        }
        setTotalCount(response?.data?.data?.adultCount);

        if (response.data?.data?.adultCount > 0) {
          if (amount > 0) {
            localStorage.setItem("DueAmount", amount);
            setTotalDue(amount);
          } else {
            localStorage.setItem("DueAmount", 0);
            setTotalDue(0);
          }
        }

        if (isSkipRegCard === true) {
          setIsSkipRegCard(isSkipRegCard);

          // if (amount > 0) {
          //   navigate(`${CHECKIN_PAYMENT}`, { replace: true });
          //   setLoading(false);
          // } else {
          //   setDoCheckin(true);
          //   setLoading(false);
          // }
          return;
        }
        setShowDiv(true);
        setLoading(false);
      } else {
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "Unable to retrieve reservation. Please check your details or proceed to the front desk for assistance."
          ),
        }));
        setLoading(false);
        return;
      }
      if (response.data.statusCode === 102) {
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: response.data.message,
        }));
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log("error" + error);
      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message,
      }));
    }
  };

  useEffect(() => {
    if (isSkipRegCard === true && Object.keys(confirmationDetails).length > 0) {
      // debugger
      updateProfileCall(isSkipRegCard);
    }
  }, [isSkipRegCard, confirmationDetails]);

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  const closeErrorModal2 = () => {
    setErrorModalData2((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  const closeErrorModal3 = () => {
    setErrorModalData3((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const closeErrorModal4 = () => {
    setErrorModalData4((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const stepEmailPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.CHECKIN_THANKYOU_PAGE
  );
  const configs = stepEmailPage?.configs;
  const emailRequired = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.EMAIL_REQUIRED
  );
  const smsRequired = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.SMS_REQUIRED
  );
  const whatsappRequired = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.WHATSAPP_REQUIRED
  );

  const confirmationDetailsHandler = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (name == "pincode") {
      if (value) setEnterPincodeValidation(false);
      else setEnterPincodeValidation(true);
      setZipCode(e.target.value);
    }

    if (name === "mobileNo") {
      setMobileNoValidation(false);
    }
    // if(name=="checkoutTime")
    // {
      
    //   const isCheckoutTimeEditable=(settings?.find(s => s.parameterName === "IsCheckoutTimeEditable")?.parameterValue ?? "").toLowerCase() === "true";
    //   if (!isCheckoutTimeEditable) {
    //     setCheckoutTimeValidation(false); // ignore validation
    //     return;
    //   }
    //   else
    //   {
    //    const dbMaxCheckoutTime = settings?.find((setting) => setting.parameterName === "MaxAllowedCheckOutTime")?.parameterValue ?? "11:00 PM";

    //   if (!value) {
    //     setCheckoutTimeValidation(true); // Empty field
    //   } else {
    //     // Parse times and compare
    //     const userTime = moment(value, "hh:mm A");
    //     const maxAllowedTime = moment(dbMaxCheckoutTime, "hh:mm A");
        
    //     if (userTime.isAfter(maxAllowedTime)) {
    //       setCheckoutTimeValidation(true); // Exceeds max
    //     } 
        
    //   }
    //   }
      
    //  }
    if (name === "jobTitle") {
      if (value) setEnterJobTitleValidation(false);
      else setEnterJobTitleValidation(true);
      //setJobTitleValidation(false);
    }
    if (name === "city") {
      if (value) setEnterCityValidation(false);
      else setEnterCityValidation(true);
    }
    if (name === "state") {
      if (value) setEnterStateValidation(false);
      else setEnterStateValidation(true);
    }
    if (name === "udfField") {
      setUdfFieldValidation(false);
    }
    if (name === "udfField2") {
      setUdfField2Validation(false);
    }
    if (name === "udfField3") {
      setUdfField3Validation(false);
    }
    if (name === "udfField4") {
      setUdfField4Validation(false);
    }
    if (name === "firstName") {
      setFirstNameValidation(false);
    }
    if (name === "lastName") {
      setLastNameValidation(false);
    }
    if (name === "documentNumber") {
      setDocumentNumberValidation(false);
    }
    if (name === "documentType") {
      setDocumentTypeValidation(false);
    }
    if (name === "addressLine1") {
      setAddressLine1Validation(false);
    }
    if (name === "gender") {
      setGenderValidation(false);
    }
    if (name === "email" && value) {
      // Auto-fill only if not already auto-filled and specific patterns are matched
      const isBackspacing = e.nativeEvent.inputType === "deleteContentBackward";
      let newValue = value;
      if (!isBackspacing) {
        if (
          value.endsWith("@y") &&
          !value.includes("@yahoo.com") &&
          enableAutomaticEmailDomain
        ) {
          newValue = value.replace("@y", "@yahoo.com");
        } else if (
          value.endsWith("@g") &&
          !value.includes("@gmail.com") &&
          enableAutomaticEmailDomain
        ) {
          newValue = value.replace("@g", "@gmail.com");
        }
      }
      value = newValue;
      setEnterEmailValidation(false);
    }
    if (name === "email") {
      setEmailValidation(!mailFormat.test(value));
    }
    if (name === "country") {
      setCountryValidation(false);
      if (value?.includes(countryCodeAddressUpdate?.parameterValue)) {
        showModalPopupModal(true);
      }
      fetchStates(value);
    }
    setConfirmationDetails((state) => ({ ...state, [name]: value }));
  };

  const gotSignature = () => {
    setUrl(signature.getTrimmedCanvas().toDataURL("image/png"));
  };
  const addConfirmationNo = (newItem) => {
    setConfirmationNos((prevItems) => [...prevItems, newItem]);
  };
  const handleCheckboxChange = (e) => {
    setUserAgreed(e.target.checked);
  };

  const handleCheckboxChange1 = (e) => {
    setGreenImperativeConsent(e.target.checked);
  };
  const handleCheckboxChange2 = (e) => {
    setMarketingConsent1(e.target.checked);
  };
  const handleCheckboxChange3 = (e) => {
    setMarketingConsent2(e.target.checked);
  };
  const handleCheckboxChange4 = (e) => {
    setRegCardConsent1(e.target.checked);
  };
  const handleCheckboxChange5 = (e) => {
    setRegCardConsent2(e.target.checked);
  };
  const handleCheckboxChange6 = (e) => {
    setRegCardConsent3(e.target.checked);
  };

  const navigateToPayment = () => {
    if (totalDue > 0) navigate(`${CHECKIN_PAYMENT}`, { replace: true });
    else navigate(`${KEY}`, { replace: true });
  };

  const clearSign = () => {
    console.log(signature);
    signature.clear();
    setSignature(null);
    setUrl(null);
  };

  const onChangeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setConfirmationDetails((preState) => ({ ...preState, [name]: value }));
    setTimeChanged(true);
  };

  useEffect(() => {
    if (!stage) {
      setLoading(true);
      // checkStep();
      setLoading(false);
    }
    setConfirmationDetails((preState) => ({
      ...preState,
      hrs: "11",
      mins: "00",
      country: reservationData?.country || "",
      // pmsProfileID: "",
      // pmsConfirmationNo: "",
    }));
  }, [reservationData]);

  //api call

  const updateProfile = async (isValidate, profilesToSend, isSkipped) => {
    // if(regCardConsent1 === false && regCardConsent2 === false && regCardConsent3 === false){
    //   setErrorModalData4((state) => ({
    //     ...state,
    //     toggleError: true,
    //     errorMessage: t("Please provide at least one consent to proceed"),
    //   }));
    // }
    try {
      let flag = true;
      if (isValidate === true && isSkipped === false) {
        setEnterEmailValidation(false);
        setCountryValidation(false);
        setMobileNoValidation(false);
        setEnterPincodeValidation(false);
        setCheckoutTimeValidation(false);
        if (
          confirmationDetails?.country?.includes(
            countryCodeAddressUpdate?.parameterValue
          )
        ) {
          popupList.forEach((field) => {
            if (
              !addressData?.pincode &&
              field.fieldCode.toLowerCase() == "pincode" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
            if (
              !addressData?.numberofResidence &&
              field.fieldCode.toLowerCase() == "addressline2" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
            if (
              !addressData?.neighborhood &&
              field.fieldCode.toLowerCase() == "neighborhood" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
            if (
              !addressData?.complement &&
              field.fieldCode.toLowerCase() == "complement" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }

            if (
              !addressData?.street &&
              field.fieldCode.toLowerCase() == "addressline1" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
            if (
              !addressData?.city &&
              field.fieldCode.toLowerCase() == "city" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
            if (
              !addressData?.state &&
              field.fieldCode.toLowerCase() == "state" &&
              field.isMandatory
            ) {
              showModalPopupModal(true);
              flag = false;
              return;
            }
          });
        }

        inputFieldList.forEach((field) => {
          let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
          if (
            !confirmationDetails.email &&
            field.fieldCode == "email" &&
            field.isMandatory
          ) {
            setEnterEmailValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Email validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.pincode &&
            field.fieldCode == "pincode" &&
            field.isMandatory
          ) {
            setEnterPincodeValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Pincode validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.jobTitle &&
            field.fieldCode == "jobTitle" &&
            field.isMandatory
          ) {
            //setJobTitleValidation(true);
            setEnterJobTitleValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Job Title validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.city &&
            field.fieldCode == "city" &&
            field.isMandatory
          ) {
            setEnterCityValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("City of Residence validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.state &&
            field.fieldCode == "state" &&
            field.isMandatory
          ) {
            setEnterStateValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("State of Residence validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.udfField &&
            field.fieldCode == "udfField" &&
            field.isMandatory
          ) {
            setUdfFieldValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Udf Field validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.udfField2 &&
            field.fieldCode == "udfField2" &&
            field.isMandatory
          ) {
            setUdfField2Validation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Udf Field 2 validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.udfField3 &&
            field.fieldCode == "udfField3" &&
            field.isMandatory
          ) {
            setUdfField3Validation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Udf Field 3 validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.udfField4 &&
            field.fieldCode == "udfField4" &&
            field.isMandatory
          ) {
            setUdfField4Validation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Udf Field 4 validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.firstName &&
            field.fieldCode == "firstName" &&
            field.isMandatory
          ) {
            setFirstNameValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("First name validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.lastName &&
            field.fieldCode == "lastName" &&
            field.isMandatory
          ) {
            setLastNameValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Last name validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.documentNumber &&
            field.fieldCode == "documentNumber" &&
            field.isMandatory
          ) {
            setDocumentNumberValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Document number validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.documentType &&
            field.fieldCode == "documentType" &&
            field.isMandatory
          ) {
            setDocumentTypeValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Document type validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.gender &&
            field.fieldCode == "gender" &&
            field.isMandatory
          ) {
            setGenderValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Gender validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !confirmationDetails.addressLine1 &&
            field.fieldCode == "addressLine1" &&
            field.isMandatory
          ) {
            setDocumentTypeValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Address validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
          if (
            !mailFormat.test(confirmationDetails.email) &&
            emailRequired &&
            field.fieldCode == "email" &&
            field.isMandatory
          ) {
            setEmailValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Email validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }

          if (
            !confirmationDetails.country &&
            field.fieldCode == "countryOfResidence" &&
            field.isMandatory
          ) {
            setCountryValidation(true);

            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Country validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);

            flag = false;
            return;
          }
          if (
            !confirmationDetails.mobileNo &&
            field.fieldCode == "phoneNo_UAE" &&
            field.isMandatory
          ) {
            // &&
            // (smsRequired || whatsappRequired)
            setMobileNoValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Mobile Number validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 2000);
            flag = false;
            return;
          }
           //For checkout time validation
           if (
            !confirmationDetails.checkoutTime &&
            field.fieldCode == "checkoutTime" &&
            field.isMandatory
          ) {
            // &&
            // (smsRequired || whatsappRequired)
            setCheckoutTimeValidation(true);
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Checkout Time validation failed"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 2000);
            flag = false;
            return;
          }

          if (
            !confirmationDetails.nationality &&
            field.fieldCode == "nationality" &&
            field.isMandatory
          ) {
            setCountryValidation(true);
            flag = false;
            return;
          }
          // if (
          //   !confirmationDetails.nationality &&
          //   field.fieldCode == "nationality" &&
          //   field.isMandatory
          // ) {
          //   setNationalityValidation(true);
          //   setErrorModalData4((state) => ({
          //     ...state,
          //     toggleError: true,
          //     errorMessage: t("Nationality validation failed"),
          //   }));

          //   flag = false;
          //   return;
          // }

          if (url === null || url === undefined) {
            setErrorModalData4((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t("Signature required"),
            }));
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            flag = false;
            return;
          }
        });
      }

      if (flag === true) {
        setLoading2(true);
        console.log(
          "EMAIL####$",
          confirmationDetails.email +
            ",proceedCount==" +
            flag +
            "," +
            proceedCount
        );
        if (proceedCount == 0) {
          dispatch(
            setEmailDetails({
              mail: confirmationDetails.email,
              phone: confirmationDetails.mobileNo,
            })
          );
        }
        let confNo = profilesToSend[0].pmsConfirmationNo;
        let reservationNameID = profilesToSend[0].reservationNameID;

        const uncheckedMandatoryConsents = userConsents
          .filter((consent) => consent.isMandatory) // only mandatory consents
          .filter((consent) => {
            const code = consent.consentCode;
            if (code === "RegCardConsent1") return !regCardConsent1;
            if (code === "RegCardConsent2") return !regCardConsent2;
            if (code === "RegCardConsent3") return !regCardConsent3;
            if (code === "GreenImperativeConsent")
              return !greenImperativeConsent;
            if (code === "MarketingConsent1") return !marketingConsent1;
            if (code === "MarketingConsent2") return !marketingConsent2;
            // add other consents here if any
            return false; // default: considered checked
          });


          //checkout time validation
          const isCheckoutTimeEditable=(settings?.find(s => s.parameterName === "IsCheckoutTimeEditable")?.parameterValue ?? "").toLowerCase() === "true";
          if (!isCheckoutTimeEditable) {
            setCheckoutTimeValidation(false); // ignore validation
            //return;
          }
          else
          {
            const dbMaxCheckoutTime = settings?.find((setting) => setting.parameterName === "MaxAllowedCheckOutTime")?.parameterValue ?? "11:00 PM";

          if (confirmationDetails.checkoutTime) {
            // Parse times and compare
            const userTime = moment(confirmationDetails.checkoutTime, "hh:mm A");
            const maxAllowedTime = moment(dbMaxCheckoutTime, "hh:mm A");
            
            if (userTime.isAfter(maxAllowedTime)) {
             //setCheckoutTimeValidation(true); // Exceeds max
                setErrorModalData4((state) => ({
                ...state,
                toggleError: true,
                errorMessage: t("Checkout Time Reached Maximum Allowed Time"),
              }));
              setLoading2(false);
              return;
            } 
            
          }
          }
          

        if (uncheckedMandatoryConsents.length > 0) {
          console.log(
            "Unchecked Mandatory Consents: ",
            uncheckedMandatoryConsents
          );

          setErrorModalData4((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t("Please provide all mandatory consents to proceed"),
          }));
          setLoading2(false);
          return;
        }

        try {
          // debugger
          const response = await updateUserProfile(profilesToSend, token);
          // debugger
          // let confNo = profilesToSend[0].pmsConfirmationNo;
          // let reservationNameID = profilesToSend[0].reservationNameID;

          if (response.data.result === false) {
            setErrorModalData2((state) => ({
              ...state,
              toggleError: true,
              errorMessage:
                response.data.message !== ""
                  ? response.data.message
                  : "Some error occured",
            }));
            setLoading2(false);
            return;
          }
          if (response.data.statusCode === 102) {
            setErrorModalData2((state) => ({
              ...state,
              toggleError: true,
              errorMessage: response.data.message,
            }));
            setLoading2(false);
            return;
          } else {
            if (
              response.data.data !== null &&
              response.data.data !== undefined &&
              response.data.data[0].pmsConfirmationNo !== null &&
              response.data.data[0].pmsConfirmationNo !== undefined
            ) {
              confNo = response.data.data[0].pmsConfirmationNo;
              reservationNameID = response.data.data[0].reservationNameID;
            }
          }
        } catch (error) {
          console.log("error" + error);
          // Handle HTTP error (400, 500, etc.)
          setErrorModalData2((state) => ({
            ...state,
            toggleError: true,
            errorMessage: "Something went wrong. Please try again.",
          }));
          setLoading2(false);
        }

        //confirmNo
        if (isSkipped === false) {
          let consents = [];

          userConsents.forEach((consent) => {
            if (consent.consentCode === "RegCardConsent1")
              consents.push({
                consentCode: "RegCardConsent1",
                consentValue: regCardConsent1 ? "true" : "false",
              });
            if (consent.consentCode === "RegCardConsent2")
              consents.push({
                consentCode: "RegCardConsent2",
                consentValue: regCardConsent2 ? "true" : "false",
              });
            if (consent.consentCode === "RegCardConsent3")
              consents.push({
                consentCode: "RegCardConsent3",
                consentValue: regCardConsent3 ? "true" : "false",
              });
            if (consent.consentCode === "GreenImperativeConsent")
              consents.push({
                consentCode: "GreenImperativeChecked",
                consentValue: greenImperativeConsent ? "true" : "false",
              });
            if (consent.consentCode === "MarketingConsent1")
              consents.push({
                consentCode: "MarketingConsent1Checked",
                consentValue: marketingConsent1 ? "true" : "false",
              });
            if (consent.consentCode === "MarketingConsent2")
              consents.push({
                consentCode: "MarketingConsent2Checked",
                consentValue: marketingConsent2 ? "true" : "false",
              });
          });

          console.log("consents===>" + JSON.stringify(consents));

          const RegCard = {
            reservationID: 0,
            confirmationNo: confNo,
            reservationNameID: reservationNameID,
            signatureBase64: url,
            propertyCode: propertyData?.data?.propertyCode,
            documentType: "RegCard",
            tnChecked: userAgreed,
            consents: consents,
            //greenImperativeChecked: greenImperativeConsent,
            // marketingConsent1Checked: marketingConsent1,
            // marketingConsent2Checked: marketingConsent2
          };
          const response2 = await saveRegistrationCard(RegCard, token);

          //if (response2.data.result === true && response2.status === 200) {
          const totalCount = parseInt(localStorage.getItem("totalCount") || 0);
          if (totalCount > 1 && propertyData?.data?.pms === "OHIP-SHARER") {
            if (
              confirmNo !== confNo &&
              confNo !== undefined &&
              confNo !== null
            ) {
              addConfirmationNo({
                ConfirmationNo: confNo,
                ReservationNameID: reservationNameID,
              });
            }

            if (isPrimarySharer) {
              setPrimaryAddressData((prevState) => ({
                ...prevState,
                countryOfResidenceCode:
                  profilesToSend[0].countryOfResidenceCode,
              }));
            }

            if (totalCount - 1 > proceedCount) {
              setIsPrimarySharer(false);
              setProceedCount((prevCount) => prevCount + 1);
              setShowMultiConfirmModal(true);
              setLoading2(false);
              return;
            }
          }
          //}
        }

        setDoCheckin(true);

        // console.log("totalAmount-==##" + totalDue);
        // if (totalDue > 0) {
        //   navigate(`${CHECKIN_PAYMENT}`, { replace: true });
        // }
        // else {

        //   console.log("profilesToSend[0].pmsConfirmationNo ==> tt " + JSON.stringify(confirmationNos));
        //   const checkinData = {
        //     confirmationNo: confirmNo,
        //     reservationNameID: userData?.reservationNameID,
        //     payment: null,
        //     confirmationNumbers: JSON.stringify(confirmationNos)
        //   };
        //
        //   const response2 = await checkIn(checkinData, token);
        //   if (response2?.data?.result === true) {
        //     setLoading2(false);
        //     setSuccessLoader(true);
        //     setTimeout(() => {
        //       setSuccessLoader(false);
        //       navigate(KEY, { replace: true });
        //     }, 2000);
        //     return;

        //   } else if (
        //     response2?.data?.message !== null &&
        //     response2?.data?.message !== ""
        //   ) {
        //     setLoading2(false);
        //     setErrorModalData((state) => ({
        //       ...state,
        //       toggleError: true,
        //       errorMessage: response2?.data?.message ?? "Checkin failed",
        //     }));
        //   } else {
        //     setSuccessLoader(false);
        //     setLoading2(false);
        //     setErrorModalData((state) => ({
        //       ...state,
        //       toggleError: true,
        //       errorMessage: "Checkin failed",
        //     }));
        //     setTimeout(() => {
        //       navigate(`${HOME}`, { replace: true });
        //     }, 2000);
        //   }
        // }
        //navigate("/passport-scan-payment");
        //let amountDue=   localStorage.getItem("DueAmount");

        return;
      }
    } catch (error) {
      console.log("error" + error);
      setLoading2(false);
      setErrorModalData2((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message ?? t("Some error occured"),
      }));
      return;
    }
  };
  const transactionGUIDSet = new Set();

  useEffect(async () => {
    if (isDoCheckin === true) {
      if (totalDue <= 0 || paymentPage === undefined || paymentPage === null) {
        await callCheckin();
      } else {
        setLoading(false);
        setLoading2(false);
        setLoading3(false);
        dispatch(setMultiConfirmationNos(confirmationNos));
        dispatch(setCheckoutTime(confirmationDetails?.checkoutTime ?? null));
        dispatch(setDepartureDate(confirmationDetails?.departureDate ?? null));
        navigate(`${CHECKIN_PAYMENT}`, { replace: true });
      }
    }
  }, [isDoCheckin]);

  const callCheckin = async () => {
    setLoading(true);
    const verifyRes = await verifyQueueOrCheckin({
      confirmationNo: confirmNo
    }, token);
    
    if (verifyRes.data?.result === true && verifyRes.data?.data === "queue")
      await moveToQueueRoom();
    else if (verifyRes.data?.result === true && verifyRes.data?.data === "checkin") {
      var fcTime;
    if(enableTimeZoneBasedCheckoutUpdate){
       fcTime=confirmationDetails?.checkoutTime ? (propertyTimeToUtc(confirmationDetails?.checkoutTime ,propertyData?.data?.timeZone)): "";
     }
    else
      {
        fcTime=confirmationDetails?.checkoutTime ?? null;
      }
      const checkinData = {
        confirmationNo: confirmNo,
        reservationNameID: userData?.reservationNameID,
        payment: null,
        confirmationNumbers: JSON.stringify(confirmationNos),
       //checkoutTime: confirmationDetails?.checkoutTime ?? null,
       //checkoutTime:confirmationDetails?.checkoutTime ? (propertyTimeToUtc(confirmationDetails?.checkoutTime ,propertyData?.data?.timeZone)): "",
       checkoutTime:fcTime,
        timeZone: propertyData?.data?.timeZone ?? null,
        departureDate:  confirmationDetails?.departureDate,
      };

      const response2 = await checkIn(checkinData, token);
      if (response2?.data?.result === true) {
        setDoCheckin(false);
        setLoading2(false);
        setLoading(false);
        setSuccessMessage(t("Checked in successfully!!"));
        setSuccessLoader(true);
        setTimeout(() => {
          setSuccessLoader(false);
          navigate(KEY, { replace: true });
        }, 200);
        return;
      }
      else {
        setLoading(false);
        setLoading2(false);
        setLoading3(false);
        setDoCheckin(false);
        setErrorModalData4((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t("Checkin failed"),
        }));
        setTimeout(() => {
          handlebackPage();
        }, 4000);
        return;
      }
    } else {
        setLoading(false);
        setLoading2(false);
        setLoading3(false);
        setDoCheckin(false);
        setErrorModalData4((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t("Checkin failed"),
        }));
        setTimeout(() => {
          handlebackPage();
        }, 4000);
        return;
    }
  };
  const cleanAddress = (address) => {
    if (!address) return "";
    return address
      .split(",")
      .map((part) => part.trim())
      .filter((part) => part.length > 0)
      .join(", ");
  };
  const moveToQueueRoom = async () => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const reservationNameID = localStorage.getItem("reservationNameID");
    const requestData = {
      confirmationNo: confirmationNo,
      reservationNameID: reservationNameID,
    };
    const resp = await queueRoom(requestData, token);
    if (resp?.data?.result === true) {
      setLoading(false);
      setSuccessMessage(t("Pre-Checked in successfully!!"));
      setSuccessLoader(true);
      setTimeout(() => {
        setSuccessLoader(false);
        navigate(CHECKIN_THANKYOU, { replace: true });
      }, 2000);
      return;
    } else {
      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "PreCheck-in Failed. Please visit front desk for assistance"
        ),
      }));
    }
  };

  //adding addLog functionality
  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Scan",
      Message: message,
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",

      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };
  const updateProfileCall = (isSkipped) => {
    let profiles = [];
    if (profileData !== null && profileData?.length > 0) {
      //console.log("-----------------------------profileData",profileData);
      profileData.forEach((el, index) => {
        //console.log("-----------el",el);
        let sharer = propertyData?.data?.pms === "OHIP-SHARER";
        let isPrimary =
          el.isPrimary === null || el.isPrimary === undefined
            ? false
            : el.isPrimary;
        let countryOfResidenceCode =
          isPrimary || sharer
            ? confirmationDetails.country
            : el?.countryCode ?? el.countryOfResidenceCode ?? el.country;
        let isBrazil =
          countryOfResidenceCode &&
          (countryOfResidenceCode.toUpperCase() === "BR" ||
            countryOfResidenceCode.toUpperCase() === "BRA");
        let getFromAddressData =
          countryCodeAddressUpdate == countryOfResidenceCode;

        let result = {
          transactionGUID: el.transactionGUID,
          pmsProfileID:
            el.pmsProfileID === null || el.pmsProfileID === undefined
              ? ""
              : el.pmsProfileID,
          guestDetailID:
            el.guestDetailID === null || el.guestDetailID === undefined
              ? ""
              : el.guestDetailID,
          isPrimary: isPrimary,
          documentBase64Image: el?.DocumentImageSide1,
          faceImageBase64Image: el?.Portrait,
          AdditionalDocumentBase64Image: el?.DocumentImageSide2,
          pmsConfirmationNo: el?.pmsConfirmationNo,
          phoneNo_UAE: (
            (isPrimary || sharer
              ? confirmationDetails.mobileNo
              : el.phoneNo_UAE) ?? ""
          ).trim(),
          email: (
            (isPrimary || sharer ? confirmationDetails.email : el.email) ?? ""
          ).trim(),
          isFaceMatched: el?.isFaceMatch ?? false,
          documentNumber: (
            (isPrimary || sharer
              ? confirmationDetails.documentNumber
              : el?.DocumentNumber) ?? ""
          ).trim(),
          documentType:
            (isPrimary || sharer
              ? confirmationDetails.documentType
              : el?.DocumentType) ?? "",
          nationalityCode: isPrimary
            ? (el?.NationalityCode?.trim() ?? confirmationDetails.nationality)
              ? el?.NationalityCode?.trim()
              : confirmationDetails.nationality
            : (el?.NationalityCode?.trim() ?? confirmationDetails.nationality),
          issueDate: el?.IssueDate,
          expiryDate: el?.ExpiryDate,
          gender:
            (isPrimary || sharer ? confirmationDetails.gender : el?.Gender) ??
            "",
          title: "",
          firstName: (
            (isPrimary || sharer
              ? confirmationDetails.firstName
              : el?.FirstName) ?? ""
          ).trim(),
          middleName: "",
          lastName: (
            (isPrimary || sharer
              ? confirmationDetails.lastName
              : el?.LastName) ?? ""
          ).trim(),
          arabicName: "",
          fullName: el?.FullName || el?.GivenName || "",
          birthPlace: "",
          dateofBirthDT: el?.DateOfBirth,
          IssueCountryCode: el?.IssueCountryCode,
          countryOfResidenceCode: countryOfResidenceCode,
          emiratesName: "",
          createdDate: "",
          placeOfIssue: "",

          // city: addressData?.city ?? "",
          city: !getFromAddressData
            ? isPrimary
              ? confirmationDetails.city
              : el.city
            : addressData?.city,
          state: !getFromAddressData
            ? isPrimary
              ? stateList.some((s) => s.stateCode == confirmationDetails?.state)
                ? confirmationDetails?.state
                : ""
              : el.state
            : addressData?.state,
          pincode: !getFromAddressData
            ? isPrimary
              ? confirmationDetails?.pincode
              : el.pincode
            : addressData?.pincode,
          addressLine1: !getFromAddressData
            ? isPrimary
              ? confirmationDetails.addressLine1 ?? ""
              : confirmationDetails.addressLine1 ?? el.addressLine1
            : addressData?.street,
          addressLine2: isPrimary
            ? addressData?.numberofResidence ?? ""
            : addressData?.numberofResidence ?? el.addressLine2, //NoofResidense
          neighborhood: isPrimary
            ? addressData?.neighborhood ?? ""
            : addressData?.neighborhood ?? el.neighborhood,
          complement: isPrimary
            ? addressData?.complement ?? ""
            : addressData?.complement ?? el.complement,
          liveFaceImage: el?.liveFaceImage,
          manualFaceAuthenticatedBy: el?.manualAuthby ?? "",
          isFaceManuallyVerified: el?.isManualAuth ?? false,
          primaryPmsConfirmationNo: confirmNo,
          primaryReservationNameID: reservationNameID,
          reservationNameID: el?.reservationNameID,
          taxNo1: el?.TaxNumber,
          jobTitle: (
            (isPrimary || sharer
              ? confirmationDetails?.jobTitle
              : el.jobTitle) ?? ""
          ).trim(),
          udfField: (
            (isPrimary || sharer
              ? confirmationDetails?.udfField
              : el.udfField) ?? ""
          ).trim(),
          udfField2: (
            (isPrimary || sharer
              ? confirmationDetails?.udfField2
              : el.udfField2) ?? ""
          ).trim(),
          udfField3: (
            (isPrimary || sharer
              ? confirmationDetails?.udfField3
              : el.udfField3) ?? ""
          ).trim(),
          udfField4: (
            (isPrimary || sharer
              ? confirmationDetails?.udfField4
              : el.udfField4) ?? ""
          ).trim(),
        };
        profiles.push(result);
        transactionGUIDSet.add(el.transactionGUID);
      });
    } else {
      let result = {
        transactionGUID: "",
        profileDocumentID: 0,
        profileID: 0,
        pmsProfileID: totalCount === 1 ? reservationData.pmsProfileID : 0,
        guestDetailID:
          totalCount === 1
            ? reservationData.guestDetailID === null ||
              reservationData.guestDetailID === undefined
              ? ""
              : reservationData.guestDetailID
            : "",
        isPrimary:
          totalCount === 1
            ? reservationData.isPrimary === null ||
              reservationData.isPrimary === undefined
              ? false
              : reservationData.isPrimary
            : false,
        documentBase64Image: "",
        faceImageBase64Image: confirmationDetails?.faceImageBase64Image,
        AdditionalDocumentBase64Image: "",
        pmsConfirmationNo: reservationData.pmsConfirmationNo,
        isPassportAdded: true,
        isFrontIDAdded: true,
        isBackIDAdded: true,
        phoneNo_UAE: confirmationDetails.mobileNo,
        email: confirmationDetails.email,
        jobTitle: confirmationDetails.jobTitle,
        isDocVerified: true,
        isFaceMatched: true,
        documentNumber: confirmationDetails.documentNumber,
        documentType: confirmationDetails.documentType,
        nationalityCode: confirmationDetails.nationality,
        issueDate: "",
        expiryDate: "",
        gender: confirmationDetails.gender,
        title: "",
        firstName: confirmationDetails.firstName,
        middleName: "",
        lastName: confirmationDetails.lastName,
        arabicName: "",
        fullName: "",
        birthPlace: "",
        dateofBirthDT: "",
        issueCountryCode: "",
        countryOfResidenceCode: confirmationDetails.country,
        emiratesName: "",
        createdDate: "",
        city: confirmationDetails?.city,
        state: stateList.some((s) => s.stateCode == confirmationDetails?.state)
          ? confirmationDetails?.state
          : "",
        pincode: confirmationDetails.pincode,
        placeOfIssue: "",
        addressLine1: confirmationDetails.addressLine1,
        addressLine2: "",
        liveFaceImage: "",
        manualFaceAuthenticatedBy: confirmationDetails?.manualAuthby ?? "",
        isFaceManuallyVerified: confirmationDetails?.isManualAuth,
        primaryPmsConfirmationNo: confirmNo,
        primaryReservationNameID: reservationNameID,
        reservationNameID: "",
        taxNo1: "",
        // udfs: userDefinedFields
        udfField: confirmationDetails?.udfField,
        udfField2: confirmationDetails?.udfField2,
        udfField3: confirmationDetails?.udfField3,
        udfField4: confirmationDetails?.udfField4,
      };
      profiles.push(result);
    }
    if (propertyData?.data?.pms === "OHIP-SHARER") {
      const distinctTransactionGUIDs = Array.from(transactionGUIDSet);
      const transactionGuid = distinctTransactionGUIDs[proceedCount];

      const profilesToSend = profiles.filter(
        (item) => item.transactionGUID == transactionGuid
      );
      setGuestCount(
        (prevCount) => prevCount + (profilesToSend?.length - 1) + 1
      ); // 2 + 1 = 3

      updateProfile(true, profilesToSend, false);
    } else {
      let profilesToSend = profiles.filter((o) =>
        Object.values(o).some((v) => v !== null)
      );
      if (isSkipped == true) updateProfile(true, profilesToSend, isSkipped);
      else updateProfile(true, profilesToSend, false);
    }
  };

  const nullUndefineEmptyStr = (strValue) => {
    if (strValue === undefined || strValue === null || strValue.trim() === "") {
      return true;
    }
    return false;
  };
  const handlebackPage = () => {
    try {
      console.error("going home page");
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };
  return (
    <div>
      {showDiv === true ? (
        <UserReservationDetails
          loading={loading}
          loading2={loading2}
          loading3={loading3}
          openModal={openModal}
          reservationData={reservationData}
          confirmationDetails={confirmationDetails}
          erroModalData={erroModalData}
          erroModalData2={erroModalData2}
          closeErrorModal={closeErrorModal}
          closeErrorModal2={closeErrorModal2}
          confirmationDetailsHandler={confirmationDetailsHandler}
          setSignature={setSignature}
          setUrl={setUrl}
          signature={signature}
          gotSignature={gotSignature}
          handleCheckboxChange={handleCheckboxChange}
          handleCheckboxChange1={handleCheckboxChange1}
          handleCheckboxChange2={handleCheckboxChange2}
          handleCheckboxChange3={handleCheckboxChange3}
          handleCheckboxChange4={handleCheckboxChange4}
          handleCheckboxChange5={handleCheckboxChange5}
          handleCheckboxChange6={handleCheckboxChange6}
          clearSign={clearSign}
          navigateToPayment={navigateToPayment}
          userAgreed={userAgreed}
          url={url}
          updateProfile={updateProfileCall}
          erroModalData3={erroModalData3}
          closeErrorModal3={closeErrorModal3}
          openCheckOutTimeModal={openCheckOutTimeModal}
          toggleCheckoutTimeModal={toggleCheckoutTimeModal}
          setTimeChanged={setTimeChanged}
          timeChanged={timeChanged}
          onChangeHandler={onChangeHandler}
          emailValidation={emailValidation}
          countryValidation={countryValidation}
          //  nationalityValidation={nationalityValidation}
          mobileNoValidation={mobileNoValidation}
          udfFieldValidation={udfFieldValidation}
          udfField2Validation={udfField2Validation}
          udfField3Validation={udfField3Validation}
          udfField4Validation={udfField4Validation}
          firstNameValidation={firstNameValidation}
          lastNameValidation={lastNameValidation}
          addressLine1Validation={addressLine1Validation}
          documentNumberValidation={documentNumberValidation}
          documentTypeValidation={documentTypeValidation}
          enterEmailValidation={enterEmailValidation}
          enterJobTitleValidation={enterJobTitleValidation}
          enterCityValidation={enterCityValidation}
          enterStateValidation={enterStateValidation}
          enterPincodeValidation={enterPincodeValidation}
          genderValidation={genderValidation}
          property={propertyData?.data}
          userData={userData}
          countries={countries}
          documentListTypes={documentListTypes}
          handlebackPage={handlebackPage}
          showModalPopup={showModalPopupModal}
          countryCodeAddressUpdate={countryCodeAddressUpdate}
          userConsents={userConsents}
          stateList={stateList}
          checkoutTimeValidation={checkoutTimeValidation}
        />
      ) : (
        <>
          <LoaderPopup loading={true} />
        </>
      )}

      <Footer
        page={"signature"}
        showModal={showModal}
        openModal={openModal}
        timerCounter={timerCounter}
        timerValue={timerValue}
        restartTimer={restartTimer}
        stopTimer={stopTimer}
        timeLimit={timeLimit}
      />
      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}
      {toggleCheckoutTimeModal && (
        <CheckoutTimeModal
          closeCheckoutTimeModal={closeCheckoutTimeModal}
          togglePackageApi={togglePackageApi}
          setTogglePackageApi={setTogglePackageApi}
        />
      )}
      <SuccessPopup
        loading={successLoader}
        successMessage={t(successMessage)}
      />
      <ErrorPopup
        closeErrorModal={closeErrorModal4}
        erroModalData={erroModalData4}
      />
      <MultipleRegCard
        showConfirmModal={showMultiConfirmModal}
        closeModal={closeModal}
        confirmSharerReg={confirmSharerReg}
      />
      {showingPopup === true && (
        <UserReservationAddressDetails
          loading={showingPopup}
          closeModalPopup={closeModalPopup}
          errorModal={popupModalData}
          //searchPinCode={fetchPostalDetails}
          addressData={addressData}
          // enterPincodeValidation={enterPincodeValidation}
          //numberofResidence={""}
          // addressChangeHandler={addressChangeHandler}
          confirmationDetails={confirmationDetails}
          onError={onError}
          onLoader={onLoader}
          onSubmit={onAddressSubmit}
        />
      )}
    </div>
  );
};

export default ReservationDetailsPassportScan;
